import React, { Component } from "react";
import { connect } from "react-redux";
import { userActions } from "../_actions";
import { userConstants } from "../_constants";
import "../assets/css/loginAdmin.css";
import logo from "../assets/images/logopwa.png";

class LoginSuperAdmin_ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cell_phone: null,
      password: null,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { cell_phone, password } = this.state;

    if (!cell_phone)
      return userActions.failure(userConstants.ERRORS["username"]);
    if (!password) return userActions.failure(userConstants.ERRORS["password"]);

    const data = {
      cell_phone,
      password,
    };

    this.props
      .dispatch(
        userActions.API("post", `v1/su_admin/signin`, data, true, false)
      )
      .then((res) => {
        localStorage.setItem("tokenSuperAdmin", JSON.stringify(res.data.token));
        this.props.history.push(`/superAdmin`);
      })
      .catch((e) => {
        const status = e.response.status;
        const errorMsg =
          status === 401
            ? "unauthorized"
            : status === 500
            ? "serverError"
            : "loginAdmin";
        userActions.failure(userConstants.ERRORS[errorMsg]);
      });
  };

  render() {
    const { handleSubmit } = this;
    return (
      <Container>
        <Logo />
        <Title />
        <Form
          onSubmit={handleSubmit}
          onName={(e) => this.setState({ cell_phone: e.target.value })}
          onPassword={(e) => this.setState({ password: e.target.value })}
        />
      </Container>
    );
  }
}

class Container extends Component {
  render() {
    return (
      <div className="login-admin">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="form-section">{this.props.children}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class Form extends Component {
  render() {
    const { onSubmit, onName, onPassword } = this.props;

    return (
      <form>
        <div className="form-group clearfix">
          <input
            name="name"
            type="text"
            className="form-control"
            placeholder="نام کاربری"
            aria-label="Full Name"
            onChange={onName}
          />
        </div>
        <div className="form-group clearfix">
          <input
            name="password"
            type="password"
            className="form-control"
            autoComplete="off"
            placeholder="رمز عبور"
            aria-label="Password"
            onChange={onPassword}
          />
        </div>
        <div className="form-group mb-0 clearfix">
          <button
            type="submit"
            className="btn btn-lg btn-primary btn-theme"
            style={{ borderRadius: "50px" }}
            onClick={onSubmit}
          >
            ورود
          </button>
        </div>
      </form>
    );
  }
}

class Title extends Component {
  render() {
    return (
      <div className="main-title">
        <h3 className="headline">
          <span className="words-wrapper">
            <b className="visible">Super Admin (copy)</b>
          </span>
        </h3>
      </div>
    );
  }
}

class Logo extends Component {
  render() {
    return (
      <div className="logo-2">
        <img src={logo} style={{ width: "110px", height: "85px" }} alt="logo" />
      </div>
    );
  }
}

const LoginSuperAdmin = connect((state) => ({
  globalStorage: state.globalStorage,
}))(LoginSuperAdmin_);

export { LoginSuperAdmin };
